import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const dealRepository = repositoryHost.getDealRepository(databaseService);
const temporaryDealRepository =
  repositoryHost.getTemporaryDealRepository(databaseService);

export const useGetDealById = (dealId: string) => {
  return useQuery({
    queryKey: ["dealId", dealId],
    queryFn: async () => {
      return dealRepository.get({ id: dealId });
    },
    enabled: !!dealId,
  });
};

export const useGetDealByTemporaryId = (temporaryDealId: string) => {
  return useQuery({
    queryKey: ["dealId", temporaryDealId],
    queryFn: async () => {
      return temporaryDealRepository.get({ id: temporaryDealId });
    },
    enabled: !!temporaryDealId,
  });
};
